import { FC, useEffect, useState } from "react"
import { PluginWrapper } from "../../../components/plugins/PluginWrapper"
import { useTabsContext } from "../../../system/providers/tabsProvider";
import { useAppContext } from "../../../system/providers/appContextProvider";
import GridMultipleSelectorInputV2 from "../../../components/controls/GridMultipleSelectorInputV2";
import { IEntitySimpleDTO } from "../../../libs/coreapi-dto/@types/common";
import useGridFilter, { CreateSelectorGridFilter } from "../../../system/hooks/useGridFilter";
import { v4 as uuidv4 } from 'uuid';
import ContractorSelectorModal from "../../Dictionaries/Contractor/ContractorSelectorModal";
import { useTranslation } from "react-i18next";
import GridWrapper from "../../../components/controls/GridWrapper";
import { TextAreaInput } from "../../../components/controls/inputs";
import { IOption, Select } from "../../../components/selects/select";
import { TaxTypesOptions } from "../../../@types/enumsGlobal";
import { CheckBox } from "../../../components/controls/checkbox";
import FlexRow from "../../../components/controls/FlexRow";
import { Button } from "../../../components/buttons/button";
import { ProgressActionSpinner } from "../../../components/progressActionSpinner/ProgressActionSpinner";
import { IContractorBatchSetTaxTypeDTO } from "../../../libs/coreapi-dto/dirs/contractor";
import { ContractorDataProvider } from "../../../Services/DataProviders/ContractorDataProvider";
import { IActRevaluationFromStoreDTO, IActRevaluationFromStoresResponse, IActRevaluationValidateStoresDto, IActRevaluationValidateStoresResponse } from "../../../libs/coreapi-dto/documents/ActRevaluation";
import { StoreDataProvider } from "../../../Services/DataProviders/StoreDataProvider";
import { ActRevaluationDataProvider } from "../../../Services/DataProviders/ActRevaluationDataProvider";
import { ConfirmationItemsModal } from "../../../components/modalWindows/ConfirmationItemsModal";
import styles from "../../../components/controls/inputs/styles/BaseInput.module.scss";
import styles2 from "../../styles/ContractorTaxTypePlugin.module.scss";
import { ActRevaluationRecalcModal } from "../../Documents/ActRevaluation/ActRevaluationCreator/ActRevaluationRecalcModal";
import GridSelectorInput from "../../../components/controls/GridSelectorInput";
import PricingModelSelectorModal from "../../Dictionaries/PricingModel/PricingModelSelectorModal";

interface IContractorTaxTypePlugin {
    plugin: IPlugin
}

interface IRevaluationOption {
    hasRetailPrice: boolean,
    eventName: string,
    valueName: string
}

export const ContractorTaxTypePlugin: FC<IContractorTaxTypePlugin> = (props) => {

    const tabCtx = useTabsContext();
    const appCtx = useAppContext();

    const contractorDP = new ContractorDataProvider(appCtx.coreApiService);
    const storeDP = new StoreDataProvider(appCtx.coreApiService);
    const actRevaluationDP = new ActRevaluationDataProvider(appCtx.coreApiService);

    const [modalWindow, setModalWindow] = useState(<></>);

    const [selectedContractors, setSelectedContractors] = useState<IEntitySimpleDTO[]>([]);
    const [contractorGridFilter, contractorDispatchGridFilter] = useGridFilter(CreateSelectorGridFilter);

    const { t } = useTranslation();
    const baseT = (value: string) => t("documents.actRevaluation." + value);

    const [currentTaxTypeOption, setCurrentTaxTypeOption] = useState<IOption>(TaxTypesOptions[2]);
    const [useVat, setUseVat] = useState<boolean>(false);
    const [pricingModel, setPricingModel] = useState<IEntitySimpleDTO | null>(null);

    const reservedLotsDocumentsMessage = "readyMessages.reservedLotsDocuments";
    const reservedOpLotsDocumentsMessage = "readyMessages.reservedOpLotsDocuments";

    const getTaxTypeForContractor = (): number => {
        let value = Number(currentTaxTypeOption.value);
        if (value === 4) value = 1;

        return value;
    }

    const saveAndClose = () => {
        setModalWindow(
            <ProgressActionSpinner
                loaderText={"Сохранение контрагентов"}
            />);
        let request = {
            idContractorGlobalList: selectedContractors.map(x => x.idGlobal),
            taxType: getTaxTypeForContractor(),
            useVat: useVat
        } as IContractorBatchSetTaxTypeDTO

        contractorDP.batchSetTaxType(request, (result) => {
            setModalWindow(<></>)
            tabCtx.closeCurrent();
        },
            (e: any) => {
                setModalWindow(<></>)
            })
    };

    const revaluate = (option: IRevaluationOption) => {
        setModalWindow(
            <ProgressActionSpinner
                loaderText={"Создание документов переоценки"}
            />);

        const contractorIdList = selectedContractors.map(x => x.idGlobal);
        let request = {
            idContractorGlobalList: contractorIdList,
            taxType: getTaxTypeForContractor(),
            useVat: useVat
        } as IContractorBatchSetTaxTypeDTO

        contractorDP.batchSetTaxType(request, (result) => {
            let expression = `"IdContractorGlobal" in (${contractorIdList.map(x => `'${x}'`).join(',')})`

            storeDP.getView({ ...CreateSelectorGridFilter, expression: expression }, (stores, totalCount) => {
                const storeIds = stores.map(x => x.idGlobal);

                // Валидация склада (наличие партий с резервом)
                actRevaluationDP.validateStores(
                    {
                        idStoreGlobalList: storeIds
                    } as IActRevaluationValidateStoresDto,
                    (result: IActRevaluationValidateStoresResponse) => {
                        if (result.isSuccess) {
                            // Создание АП
                            let revaluation = {
                                idStoreGlobalList: storeIds,
                                revaluationTaxType: Number(currentTaxTypeOption.value),
                                hasRetailPrice: option.hasRetailPrice,
                                eventName: option.eventName,
                                valueName: option.valueName,
                                idPricingModel: pricingModel?.idGlobal
                            } as IActRevaluationFromStoreDTO

                            actRevaluationDP.createFromStoreMany(revaluation, (response: IActRevaluationFromStoresResponse) => {
                                let infoMessages = `Созданы документы переоценки в количестве: ${response.actsRevaluationCreatedNo}\n\n`;
                                infoMessages += response.infoMessages;

                                setModalWindow(
                                    <ConfirmationItemsModal
                                        header={"Акт переоценки"}
                                        warning={""}
                                        listPositions={infoMessages}
                                        question={"Открыть вкладку журнала \"Акт переоценки\" ?"}
                                        largeTextArea
                                        cancel={() => {
                                            if (response.actsRevaluationCreatedNo > 0) tabCtx.closeCurrent();
                                            setModalWindow(<></>);
                                        }
                                        }
                                        ok={() => {
                                            setModalWindow(<></>);
                                            tabCtx.closeCurrent();
                                            tabCtx.open('act_revaluation_plugin');
                                        }}
                                    />
                                );
                            }, (e: any) => { setModalWindow(<></>) });
                        } else {
                            // Вывод подробной ошибки о неготовности операции
                            setModalWindow(
                                <ConfirmationItemsModal
                                    header={"Переоценка невозможна"}
                                    largeTextArea
                                    warning={""}
                                    listPositions={`${result.errorMessage
                                        .replace(reservedLotsDocumentsMessage, baseT(reservedLotsDocumentsMessage))
                                        .replace(reservedOpLotsDocumentsMessage, baseT(reservedOpLotsDocumentsMessage))}`}
                                    question={""}
                                    cancel={() => setModalWindow(<></>)}
                                />
                            );
                        }
                    },
                    () => {
                        setModalWindow(<></>);
                    }
                )
            })
        },
            (e: any) => {
                setModalWindow(<></>)
            })
    }

    const saveAndRevaluate = () => {
        setModalWindow(<ActRevaluationRecalcModal
            header={'Выберите вариант переоценки партий'}
            label={''}
            hideOnOk={false}
            options={[
                { value: "recountModelValuesOption", label: baseT("recountModelValuesOption") },
                { value: "recountFixRetailPrice", label: baseT("recountFixRetailPrice") },
                { value: "recountVatUp", label: baseT("recountVatUp") }
            ]}
            selectedValue={undefined}
            onSelect={(value: any) => {
                switch (value) {
                    case "recountModelValuesOption":
                        revaluate(
                            {
                                eventName: "QuantityСhanged",
                                hasRetailPrice: false,
                                valueName: "QuantityRem"
                            })
                        break;

                    case "recountFixRetailPrice":
                        revaluate(
                            {
                                eventName: "RetailPriceWithVatChanged",
                                hasRetailPrice: true,
                                valueName: "RetailCostInfo.PriceIncVat"
                            })
                        break;

                    case "recountVatUp":
                        revaluate(
                            {
                                eventName: "RetailPriceChanged",
                                hasRetailPrice: true,
                                valueName: "RetailCostInfo.PriceIncVat"
                            })
                        break;

                    default:
                        break;
                }
            }}
            cancel={() => {
            }}
            close={() => setModalWindow(<></>)}
        />)
    };

    return (
        <>
            <PluginWrapper>
                <FlexRow><br /></FlexRow>
                <GridWrapper cols={2}>
                    <GridMultipleSelectorInputV2
                        selectedEntity={selectedContractors?.[0]}
                        selectedEntities={selectedContractors}
                        id={`idContractor-${uuidv4()}`}
                        switchOnchange
                        gridFilter={contractorGridFilter}
                        selectorModalJsx={ContractorSelectorModal}
                        label={t("directory.contractors.taxType.selectContractors")} // Выбор контрагентов
                        onSelect={(entities: IEntitySimpleDTO[]) => {
                            setSelectedContractors(entities);
                        }}
                        onClear={() => {
                            setSelectedContractors([]);
                        }}
                        treeViewCheckDirectoryType={'pharmacy'}
                        activateGroupProcessing
                        viewMode
                        applyUserFilter
                    />
                </GridWrapper>
                <div><br /></div>
                <GridWrapper cols={4}>
                    <GridWrapper cols={1}>
                        <FlexRow></FlexRow>
                        <FlexRow>
                            <label style={{ marginLeft: 5, whiteSpace: 'pre-line', marginBottom: 15 }}><b>  {t("directory.contractors.taxType.warning")}</b></label>
                        </FlexRow>
                        <FlexRow>
                            <CheckBox
                                id={`contractor-tax-type-${uuidv4()}`}
                                label={t("directory.contractors.taxType.useVat")}
                                defaultChecked={useVat}
                                onChanged={(value) => {
                                    setUseVat(value);
                                }}
                            />
                        </FlexRow>
                        <FlexRow>
                            <label style={{ marginLeft: 5, marginTop: 10, marginBottom: 5 }}>{`${t("directory.contractors.taxType.selectTaxType")}:`}</label>
                        </FlexRow>
                        <Select
                            style={{ width: "85%", marginLeft: 5, marginTop: -5 }}
                            defaultOption={TaxTypesOptions[2]}
                            onSelect={(option) => {
                                setCurrentTaxTypeOption(option);
                            }}
                            value={currentTaxTypeOption}
                            options={TaxTypesOptions}
                        />
                        <GridSelectorInput
                            className={styles2.priceModelSelector}
                            selectorModalJsx={PricingModelSelectorModal}
                            label={`${baseT("pricingModelOne")}:`}
                            id={`pricingModel-master-rev`}
                            selectedEntity={pricingModel}
                            onSelect={(value: IEntitySimpleDTO) => {
                                setPricingModel(value);
                            }}
                            onClear={() => setPricingModel(null)}
                        />
                        <div><br /></div>
                    </GridWrapper>
                    <TextAreaInput
                        className={styles.largeTextAreaWithHeight}
                        style={{ '--textarea-height': `${387}px` } as React.CSSProperties}
                        readonly
                        value={selectedContractors.length > 0 ? selectedContractors.map(x => x.displayName).join('\n') : String.fromCharCode(0)}
                    >
                    </TextAreaInput>
                </GridWrapper>
                <GridWrapper cols={4}>
                    <Button
                        variant={"primary"}
                        disabled={selectedContractors.length === 0}
                        onClick={saveAndClose}
                    >
                        {t("general.saveAndClose")}
                    </Button>
                    <Button
                        variant={"primary"}
                        disabled={selectedContractors.length === 0}
                        onClick={saveAndRevaluate}
                    >
                        {t("directory.contractors.taxType.saveAndRevaluate")}
                    </Button>
                </GridWrapper>
                {modalWindow}
            </PluginWrapper>
        </>
    )
}